export default "__VITE_ASSET__CpkXdN9t__"